import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  OnChanges,
} from "@angular/core";
import { FormGroup, FormsModule, ReactiveFormsModule } from "@angular/forms";
import { DisplayPdfFrameService } from "../../../../core/services/display-pdf-frame.service";
import { EnumOrderEmailState } from "../../../../shared/enums/orderEmailState.enum";
import { ActivatedRoute } from "@angular/router";
import { PoEmailData } from "../../../../core/models/orders/PoEmailData";
import { CommonModule } from "@angular/common";
import { EmailTemplates } from "../../../../core/models/orders/emailTemplates";
import { SelectModule } from "primeng/select";
import { InputTextModule } from "primeng/inputtext";
import { DropdownModule } from "primeng/dropdown";
import { CheckboxModule } from "primeng/checkbox";
import { CardModule } from "primeng/card";

@Component({
  selector: "jni-po-email-header",
  templateUrl: "./po-email-header.component.html",
  styleUrls: ["./po-email-header.component.scss"],
  imports: [
    FormsModule,
    CommonModule,
    ReactiveFormsModule,
    SelectModule,
    InputTextModule,
    DropdownModule,
    CheckboxModule,
    CardModule,
  ],
})
export class PoEmailHeaderComponent implements OnInit, OnChanges {
  @Input() displayRushRevisedSection = true;
  @Input() parent!: FormGroup;
  @Input() templates: EmailTemplates[] = [];
  @Input() poNumber: string[] = [];
  @Input() formErrors: Record<string, string> = {};
  @Input() validationMessages: Record<string, Record<string, string>> = {};
  @Input() emailButtonStatus = false;
  @Input() poNumberRevision: string[] = [];
  @Input() poEmailData: PoEmailData = {} as PoEmailData;
  @Output() fetchVendorInformation = new EventEmitter();
  @Output() templateSelectedEvent = new EventEmitter();
  @Output() logValidationErrorsEvent = new EventEmitter();
  @Output() sendEmailEvent = new EventEmitter();
  @Output() fetchWatermarkedPdf = new EventEmitter<{
    rush: boolean;
    revised: boolean;
  }>();

  base64 = "";
  rush = "Rush";
  revised = "Revised";
  rushRevised = "Rush/Revised";
  rushCheck = false;
  revisedCheck = false;
  additionalSubject = "";
  displayPoSection = true;
  displaySaleOrderSection = false;
  windowState = 0;
  saleOrderId = "";

  constructor(
    private displayPdfFrameService: DisplayPdfFrameService,
    private _activatedRoute: ActivatedRoute
  ) {
    this._activatedRoute.params.subscribe(params => {
      this.windowState = params["windowState"] ?? 0;
      this.saleOrderId = params["id"];
    });
  }

  ngOnInit(): void {
    //this.rushRevisedFieldDisabled();
    this.onPONumber();
    this.onRush();
    this.onRevised();
    this.onTemplate();

    if (
      this.windowState == EnumOrderEmailState.ProjectConfirmation ||
      this.windowState == EnumOrderEmailState.PrintOrderSummary ||
      this.windowState == EnumOrderEmailState.PrintProjectApproval
    ) {
      this.displayPoSection = false;
      this.displaySaleOrderSection = true;
    }
  }

  ngOnChanges(): void {
    if (this.poEmailData?.windowState) {
      this.saleOrderId = this.poEmailData.saleOrderId;
      this.windowState = this.poEmailData.windowState;
      this.patchValueInSubject("", "");
    }
  }

  onRush() {
    this.displayPdfFrameService.selectedRush$.subscribe(value => {
      this.onRushSelection(value ?? "");
    });
  }

  onRevised() {
    this.displayPdfFrameService.selectedRevised$.subscribe(value => {
      this.onRevisedSelection(value ?? "");
    });
  }

  onTemplate() {
    this.displayPdfFrameService.selectedtemplates$.subscribe(() => {
      this.onTemplateSelection();
    });
  }

  onPONumber() {
    this.displayPdfFrameService.selectedpoNumber$.subscribe(() => {
      this.onPONumberSelection();
    });
  }

  logValidationErrors() {
    this.logValidationErrorsEvent.emit();
  }

  onPONumberSelection() {
    this.parent.patchValue({
      header: {
        subject: `Nadel PO - ${
          this.parent.get(["header", "poNumber"])?.value ?? ""
        }`,
      },
    });
    this.fetchVendorInformation.emit(
      this.parent.get(["header", "poNumber"])?.value ?? ""
    );

    const poNumber = this.parent.get(["header", "poNumber"])?.value;
    if (poNumber) {
      this.rushRevisedFieldEnable();
      this.onRushSelection("");
      this.onRevisedSelection("");
    } else {
      this.rushRevisedFieldDisabled();
      this.clearRushRevisedField();
    }
  }

  rushRevisedFieldEnable() {
    this.parent.get(["header", "rush"])?.enable();
    this.parent.get(["header", "revised"])?.enable();
    this.parent.get(["header", "additionalSubject"])?.enable();
  }

  rushRevisedFieldDisabled() {
    this.parent.get(["header", "rush"])?.disable();
    this.parent.get(["header", "revised"])?.disable();
    this.parent.get(["header", "additionalSubject"])?.disable();
  }

  clearRushRevisedField() {
    this.parent.patchValue({
      header: {
        rush: false,
        revised: false,
        additionalSubject: "",
      },
    });
    this.rushCheck = false;
    this.revisedCheck = false;
    this.additionalSubject = "";
  }

  onTemplateSelection() {
    this.templateSelectedEvent.emit(
      this.parent.get(["header", "templateId"])?.value || 0
    );
  }

  onRushSelection(event?: Event | string) {
    if (event && typeof event !== "string") {
      const target = event?.target as HTMLInputElement;
      if (target) {
        this.rushCheck = target?.checked;
      }
    }
    if (this.rushCheck && this.revisedCheck) {
      this.patchValueInSubject(this.rushRevised, this.additionalSubject);
    } else {
      if (this.rushCheck && !this.revisedCheck) {
        this.patchValueInSubject(this.rush, this.additionalSubject);
      } else if (!this.rushCheck && this.revisedCheck) {
        this.patchValueInSubject(this.revised, this.additionalSubject);
      } else if (!this.rushCheck && !this.revisedCheck) {
        this.patchValueInSubject("", this.additionalSubject);
      }
    }
    this.addPdfWaterMark();
  }

  onRevisedSelection(event?: Event | string) {
    if (event && typeof event !== "string") {
      const target = event?.target as HTMLInputElement;
      if (target) {
        this.revisedCheck = target?.checked;
      }
    }
    if (this.rushCheck && this.revisedCheck) {
      this.patchValueInSubject(this.rushRevised, this.additionalSubject);
    } else {
      if (this.rushCheck && !this.revisedCheck) {
        this.patchValueInSubject(this.rush, this.additionalSubject);
      } else if (!this.rushCheck && this.revisedCheck) {
        this.patchValueInSubject(this.revised, this.additionalSubject);
      } else if (!this.rushCheck && !this.revisedCheck) {
        this.patchValueInSubject("", this.additionalSubject);
      }
    }

    this.addPdfWaterMark();
  }

  addPdfWaterMark() {
    this.fetchWatermarkedPdf.emit({
      rush: this.rushCheck,
      revised: this.revisedCheck,
    });
  }

  patchValueInSubject(value: string, additionalSubject: string) {
    if (this.windowState == EnumOrderEmailState.PrintOrderSummary) {
      this.parent.patchValue({
        header: {
          subject: `Nadel: Order Summary - ${
            this.parent.get(["header", "saleOrderId"])?.value ?? ""
          }  ${value}`,
        },
      });
    } else if (this.windowState == EnumOrderEmailState.ProjectConfirmation) {
      this.parent.patchValue({
        header: {
          subject: `Nadel: Project Confirmation - ${
            this.parent.get(["header", "saleOrderId"])?.value ?? ""
          }  ${value}`,
        },
      });
    } else if (this.windowState == EnumOrderEmailState.PrintProjectApproval) {
      this.parent.patchValue({
        header: {
          subject: `Nadel: Project Approval - ${
            this.parent.get(["header", "saleOrderId"])?.value ?? ""
          }  ${value}`,
        },
      });
    } else if (value && !additionalSubject) {
      this.parent.patchValue({
        header: {
          subject: `Nadel PO - ${
            this.parent.get(["header", "poNumber"])?.value ?? ""
          } - ${value}`,
        },
      });
    } else if (value && additionalSubject) {
      this.parent.patchValue({
        header: {
          subject: `Nadel PO - ${
            this.parent.get(["header", "poNumber"])?.value ?? ""
          } - ${value} - ${additionalSubject}`,
        },
      });
    } else if (!value && additionalSubject) {
      this.parent.patchValue({
        header: {
          subject: `Nadel PO - ${
            this.parent.get(["header", "poNumber"])?.value ?? ""
          } - ${additionalSubject}`,
        },
      });
    } else {
      this.parent.patchValue({
        header: {
          subject: `Nadel PO - ${
            this.parent.get(["header", "poNumber"])?.value ?? ""
          }`,
        },
      });
    }
  }

  onAdditionalSubject(event: Event) {
    const target = event.target as HTMLInputElement;
    this.additionalSubject = target!.value;
    if (this.additionalSubject) {
      if (this.rushCheck && this.revisedCheck) {
        this.patchValueInSubject(this.rushRevised, this.additionalSubject);
      } else if (this.windowState == EnumOrderEmailState.PrintOrderSummary) {
        this.parent.patchValue({
          header: {
            subject: `Nadel: Order Summary - ${
              this.parent.get(["header", "saleOrderId"])?.value ?? ""
            }  - ${this.additionalSubject}`,
          },
        });
      } else if (this.windowState == EnumOrderEmailState.ProjectConfirmation) {
        this.parent.patchValue({
          header: {
            subject: `Nadel: Project Confirmation - ${
              this.parent.get(["header", "saleOrderId"])?.value ?? ""
            }  - ${this.additionalSubject}`,
          },
        });
      } else if (this.windowState == EnumOrderEmailState.PrintProjectApproval) {
        this.parent.patchValue({
          header: {
            subject: `Nadel: Project Approval - ${
              this.parent.get(["header", "saleOrderId"])?.value ?? ""
            }  - ${this.additionalSubject}`,
          },
        });
      } else {
        if (this.rushCheck && !this.revisedCheck) {
          this.patchValueInSubject(this.rush, this.additionalSubject);
        } else if (!this.rushCheck && this.revisedCheck) {
          this.patchValueInSubject(this.revised, this.additionalSubject);
        } else if (!this.rushCheck && !this.revisedCheck) {
          this.patchValueInSubject("", this.additionalSubject);
        }
      }
    } else {
      this.additionalSubject = "";
      if (this.rushCheck && this.revisedCheck) {
        this.patchValueInSubject(this.rushRevised, this.additionalSubject);
      } else {
        if (this.rushCheck && !this.revisedCheck) {
          this.patchValueInSubject(this.rush, this.additionalSubject);
        } else if (!this.rushCheck && this.revisedCheck) {
          this.patchValueInSubject(this.revised, this.additionalSubject);
        } else if (!this.rushCheck && !this.revisedCheck) {
          this.patchValueInSubject("", this.additionalSubject);
        }
      }
    }
  }

  onEmailPO() {
    this.sendEmailEvent.emit();
  }
}
